module.exports = __webpack_public_path__ + "img/stalk-top.9d5512d9.svg";